/// <amd-module name="Dashboards/Common/DashboardsNotificationService" />
import { IVssObservableService, Services, VssObservableService } from "VSS/Platform/Context";

export const IDashboardsNotificationServiceName = "IDashboardsNotificationService";

export interface IDashboardsNotificationService extends IVssObservableService<IDashboardsNotificationRefreshing> {
    notifyDashboardRefreshing(): void;
}

export interface IDashboardsNotificationRefreshing {}

export const enum DashboardsNotificationServiceActions {
    DashboardRefreshingAction = "dashboardRefreshing"
}

/** Service handling pub/sub for dashboard events */
export class DashboardsNotificationService extends VssObservableService<IDashboardsNotificationRefreshing> implements IDashboardsNotificationService {
    /** Emit notification that the current dashboard is refreshing */
    public notifyDashboardRefreshing(): void {
        this._notify({}, DashboardsNotificationServiceActions.DashboardRefreshingAction);
    }
}

Services.add(IDashboardsNotificationServiceName, { serviceFactory: DashboardsNotificationService });
